import common from "@/store/common/module/common";
import { doGet } from "@/store/common/module/apis";
import Vue from "vue";

class I18n {
  VM: any | null = null;

  constructor() {
    this.VM = new Vue({
      data: () => ({
        notifs: [],
        count: 0,
        translates: {},
      }),
    });
  }
  get state() {
    return this.VM.$data;
  }

  get count() {
    return this.VM.$data.count;
  }

  t(text) {
    const lang = common.lang;
    if (
      lang == "en" ||
      lang == null ||
      this.VM == null ||
      this.VM.$data.translates[lang] == undefined
    ) {
      if (
        lang !== "en" &&
        lang !== null &&
        this.VM.$data.translates[lang] != null
      )
        setTimeout(() => {
          doGet("/api/o/i18n/translate?key=" + text);
        }, 100);
      return text;
    }
    try {
      const tl = this.VM.$data.translates[lang][text];
      if (tl == undefined) {
        setTimeout(() => {
          doGet("/api/o/i18n/translate?key=" + text);
        }, 100);
        return text;
      }
      return tl;
    } catch (e) {
      console.log(e);
    }
    return text + "-" + lang;
  }
}

const i18n = {
  Store: I18n,
  install(Vue, options) {
    Vue.mixin({
      beforeCreate() {
        this.$i18n = options.store;
        this.$tt = options.store.t;
      },
    });
  },
};
export default i18n;
